/* eslint-disable react/jsx-props-no-spreading */
import TimeTracking, { TimeTrackingProps } from './timeTracking';
import useTimeTrackingWithCondition from './useTimeTrackingWithCondition';

export type TimeTrackingWithConditionProps = TimeTrackingProps & {
  reportData?: { report?: { isRenderingBackground?: boolean; status?: string } };
  aiProcessing?: boolean;
  isOpenNoApiCallingModal?: boolean;
  isExpiredToken?: boolean;
};

/**
 * Gates report time tracking behind the conditions computed for the current study session. Delegates the decision to useTimeTrackingWithCondition and forwards every prop unchanged to TimeTracking when tracking is enabled, rendering nothing otherwise.
 *
 * @param props - Time-tracking inputs forwarded verbatim, covering the active tab, profile and report identifiers and the connection and loading flags.
 * @returns The time-tracking element when tracking is enabled, otherwise a falsy value that renders nothing.
 */
const TimeTrackingWithCondition = (props: TimeTrackingWithConditionProps) => {
  const { isTrackingEnabled } = useTimeTrackingWithCondition(props);

  return isTrackingEnabled && <TimeTracking {...props} />;
};

export default TimeTrackingWithCondition;
